{
  "version": "1.0",
  "chart": "table-matrix",
  "// about": "Self-contained config for the unified Table & Matrix family (Normal / Editable / Drill-Down), mirroring scatter-bubble.json. The DVM Layout Builder loads the shell and deep-merges this file (layoutSteps by key; options per-key — objects deep, arrays concatenated). These are REAL HTML tables (not ECharts). Shared option lists (numberScales, sortDirections, paletteOptions) come from bar-column.json. Only table-specific lists + this chart's types/defaults/formatControls live here.",
  "layoutSteps": {
    "TABLE_MATRIX": {
      "label": "Table & matrix",
      "sections": [
        {
          "id": "config",
          "title": "Chart configuration",
          "fields": [
            {
              "field": "layoutType",
              "label": "Chart layout",
              "control": "select",
              "optionsKey": "layoutTypes",
              "required": true
            },
            {
              "field": "title",
              "label": "Title",
              "control": "text",
              "required": true
            },
            {
              "field": "dataset",
              "label": "Dataset",
              "control": "select",
              "required": true
            }
          ]
        },
        {
          "id": "tableMatrix",
          "title": "Table & matrix",
          "fields": [
            {
              "field": "tableType",
              "label": "Table type",
              "control": "select",
              "optionsKey": "tableTypes",
              "required": true
            },
            {
              "field": "columns",
              "label": "Columns",
              "control": "select",
              "visibleWhenType": [
                "normal",
                "editable",
                "grouped",
                "treegrid",
                "financial"
              ],
              "hint": "One row per column — each picks its own dataset (defaults to the primary one), column, header display name, and an OPTIONAL default filter (filterField/filterOperator/filterValue) carried directly on that column entry. 'Filter column' defaults to the row's own column but can be pointed at ANY other column (e.g. attach a rule_categories = 'Certifications' filter to the Rule Name row even though rule_categories isn't itself displayed). Applied on the table's very first data request, before any global filter is picked. Leave a row's filter value blank for no default filtering from it; leave the whole list empty to show every column of the primary dataset. Each column row also has an Editable toggle + input type: on Editable tables columns default to editable (uncheck to lock one read-only); on Normal tables columns default to read-only (check to make just that column cell-editable, with Save/Cancel but no row add/delete)."
            },
            {
              "field": "groupBy",
              "label": "Group rows by",
              "control": "select",
              "visibleWhenType": [
                "normal"
              ]
            },
            {
              "field": "aggregation",
              "label": "Aggregation",
              "control": "select",
              "optionsKey": "tmAggregations",
              "visibleWhenType": [
                "normal",
                "matrix",
                "pivot",
                "grouped"
              ]
            },
            {
              "field": "dimensions",
              "label": "Hierarchy dimensions",
              "control": "select",
              "visibleWhenType": [
                "drilldown"
              ]
            },
            {
              "field": "measures",
              "label": "Measures",
              "control": "select",
              "visibleWhenType": [
                "drilldown"
              ]
            },
            {
              "field": "dataMode",
              "label": "Data computation",
              "control": "select",
              "optionsKey": "drillDataModes",
              "visibleWhenType": [
                "drilldown"
              ],
              "hint": "Client-side (default for new tables): the flat compute contract returns the joined rows and the browser builds the hierarchy, pivot columns and formulas — this is what enables multiple datasets, pivot columns and formula columns. Backend tree: the legacy dimensions+measures compute (tables saved before the merge keep this)."
            },
            {
              "field": "totalsPlacement",
              "label": "Totals",
              "control": "select",
              "optionsKey": "drillTotalsPlacements",
              "visibleWhenType": [
                "drilldown"
              ],
              "hint": "Where totals show. The measures ticked 'Show in Grand Total' are the totalled ones in BOTH places. Bottom = the sticky grand-total row. Right = a trailing 'Total' block across the pivot column values; Left = the same block placed directly after the first-level column (Market Segment | TOTAL | NACA | APAC | …) — each totalled measure summed over Mining + Rail + Marine + …, plus any formula column whose inputs are all totalled (evaluated on those totals, e.g. Impact); text attributes stay out (needs a pivot column dimension). options.drillRowTotalColumnsPreset narrows that block to the listed columns only (design: Revenue | Price % | Impact). A measure's 'Header in Total block' renames its column inside that block only (e.g. Revenue over the summed Sales). Both (default) = the Figma layout: TOTAL block at the right AND the total row at the bottom. None hides both."
            },
            {
              "field": "columnDimensions",
              "label": "Pivot column dimension(s)",
              "control": "select",
              "visibleWhenType": [
                "drilldown"
              ],
              "hint": "Optional. Every measure fans out per distinct value of this column — e.g. fiscal_year → 2024 Net Sales | 2025 Net Sales | … with a grand total per year column (the Pivot Table's column fields). The VALUE sequence (the header bands: Mining | Marine | Oil & Gas | Rail) follows the dimension's 'Column order' box when filled in, else options.drillPivotValueOrderPreset (the design's vertical order); values the preset does not list follow in data order, years sort ascending. Client-side computation only."
            },
            {
              "field": "computedColumns",
              "label": "Formula columns",
              "control": "select",
              "visibleWhenType": [
                "drilldown"
              ],
              "hint": "Computed per row of the tree from that row's aggregated measures (a ratio at a parent divides the sums, it doesn't average the children) and re-evaluated live after a value edit. Reference measures by their header text, e.g. ([Net Sales] - [Total Cost]) / [Net Sales] * 100."
            },
            {
              "field": "columnOrder",
              "label": "Column order",
              "control": "select",
              "visibleWhenType": [
                "drilldown"
              ],
              "hint": "One list of every output column (measure blocks + formula columns) in render order — Move up / Move down to arrange the table by hand. By DEFAULT the order follows options.drillColumnOrderPreset (the design's column sequence: Cost increase | Realized Cost Increase | Qty per year | Net Sales / Sales per year | SSA% per year | Margin % per year | Price change percentage | Impact | AOP Target | Voice of Business | Price recommended | Pricing Action reason): whichever of those columns a table has render in that order, any other column follows in measure order. Preset entries are 'name|alias|…' and match ignoring case, spaces and punctuation — edit that list to change the house order for EVERY drill-down table. A hand-made order on a tile overrides the preset. Client-side computation only. Remove this field to hide the list."
            },
            {
              "field": "rowField",
              "label": "Row dimension",
              "control": "select",
              "visibleWhenType": [
                "matrix"
              ]
            },
            {
              "field": "columnField",
              "label": "Column dimension",
              "control": "select",
              "visibleWhenType": [
                "matrix"
              ]
            },
            {
              "field": "valueField",
              "label": "Value (measure)",
              "control": "select",
              "visibleWhenType": [
                "matrix",
                "pivot"
              ]
            },
            {
              "field": "rowFields",
              "label": "Row fields",
              "control": "select",
              "visibleWhenType": [
                "pivot"
              ]
            },
            {
              "field": "columnFields",
              "label": "Column fields",
              "control": "select",
              "visibleWhenType": [
                "pivot"
              ]
            },
            {
              "field": "groupByFields",
              "label": "Group by (levels)",
              "control": "select",
              "visibleWhenType": [
                "grouped"
              ]
            },
            {
              "field": "treeIdField",
              "label": "Row ID column",
              "control": "select",
              "visibleWhenType": [
                "treegrid"
              ]
            },
            {
              "field": "treeParentField",
              "label": "Parent ID column",
              "control": "select",
              "visibleWhenType": [
                "treegrid"
              ]
            },
            {
              "field": "roleField",
              "label": "Row role column (header/item/subtotal/total)",
              "control": "select",
              "visibleWhenType": [
                "financial"
              ]
            },
            {
              "field": "indentField",
              "label": "Indent column (optional)",
              "control": "select",
              "visibleWhenType": [
                "financial"
              ]
            }
          ]
        }
      ]
    }
  },
  "options": {
    "// cellNavigation": "Every column card's 'Cell formatting' carries an 'On click' setting (table-cell-config.ts `navigation`): Published dashboard (filtered by this row) opens /dvm-published/<slug>?filterKey=<field>&filterValue=<row value>[&filterTargets=<ids>] when the cell value is clicked — for EVERY table type and display kind (link displays / hyperlink controls render an anchor, other cells are clickable as a whole). The dashboard list comes from the builder host (published + saved dashboards). 'Route' passes a button-style navigateAction through instead.",
    "// tableTypes": "The table TYPES — FULLY config-driven. `group` places the type under a heading in the Type dropdown (Standard / Interactive). RENDER-dispatch flags (drive the component + builder, no type-name checks in code): `normal`=read-only HTML table; `editable`=inline-edit CRUD; `drilldown`=hierarchical tree (reuses lib-drill-down). The Drill-Down Table is the MERGED drill-down + pivot: multiple datasets, formula columns, editable columns, Level-1-by-default hierarchy and pivot column fan-out all live there, so the former separate 'Pivot Table' entry (value 'pivot'; builder/renderer code intact for old tiles) is no longer listed. Adding a new table type = a JSON edit + (for a genuinely new renderer) a component branch.",
    "tableTypes": [
      {
        "label": "Normal Table",
        "value": "normal",
        "group": "Standard",
        "normal": true,
        "hint": "Read-only: search, sort, freeze, paginate, conditional formatting, totals, CSV export."
      },
      {
        "label": "Matrix Table",
        "value": "matrix",
        "group": "Standard",
        "matrix": true,
        "hint": "Cross-tab: one row dimension down, a column dimension's values fan out ACROSS as separate columns (e.g. Fiscal Year → 2024 | 2025 | 2026)."
      },
      {
        "label": "Editable Table",
        "value": "editable",
        "group": "Interactive",
        "editable": true,
        "hint": "Inline cell/row editing with basic input controls + validation (client-side)."
      },
      {
        "label": "Drill-Down Table",
        "value": "drilldown",
        "group": "Interactive",
        "drilldown": true,
        "hint": "Hierarchical analytical tree with the pivot table merged in: hierarchy levels (opens at Level 1, expand to drill down), measures from one or MORE datasets, optional pivot column dimension (a column block per value, e.g. per year), formula columns, editable values/labels, subtotals + grand total."
      },
      {
        "label": "Nested Table",
        "value": "nested",
        "group": "Interactive",
        "nested": true,
        "hint": "Each row opens the next level as its own table (e.g. Region → Customer), every level with its own columns. Built by the Nested Table form."
      }
    ],
    "// drillDataModes": "Drill-Down Table 'Data computation' picker. client = flat rows via the cross-dataset flat compute contract, tree/pivot/formulas built in the browser (the merged drill-down + pivot); server = legacy backend dimensions+measures tree (no multi-dataset / pivot columns).",
    "drillColumnOrderPreset": [
      "Cost increase|Cost Increase %",
      "Realized Cost Increase|Cost Increase Percentage|Realized Cost Increase %",
      "Qty|Net Quantity|Quantity",
      "Net Sales|Sales|Revenue|Rev",
      "SSA%|SSA %",
      "Margin %|Margin|Margin Percentage",
      "Price change percentage|Price Change %|Price %|Price Change",
      "Impact",
      "AOP Target|2026 AOP Target",
      "Voice of Business",
      "Price recommended|Recommended Price",
      "Pricing Action reason|Price Action Reason|Pricing Action Reason"
    ],
    "// drillPivotValueOrderPreset": "Drill-Down Table: DEFAULT sequence of the pivot column dimension's VALUES (the top header bands with 'Header grouping' = column value, e.g. Mining | Marine | Oil & Gas | Rail | Total). Entries are 'name|alias|…' matched ignoring case, spaces and punctuation. Listed values render first in this order, any other value follows in data order, the Total block stays last. A value typed into the pivot dimension's 'Column order' box on a tile overrides the preset. Baked into the tile as columnValueOrderPreset at Generate — published tiles need Update Configuration to pick up an edit.",
    "drillPivotValueOrderPreset": [
      "Mining",
      "Marine",
      "Oil & Gas|Oil and Gas|Oil&Gas|OilGas",
      "Rail",
      "Power Generation|PowerGen|Power Gen",
      "Construction",
      "Agriculture|Agri"
    ],
    "// drillRowTotalColumnsPreset": "Drill-Down Table: WHICH columns the right-hand 'Total' block shows (Totals = Right / Both) — the design's trailing 'TOTAL | Revenue | Price % | Impact' block. Entries are 'name|alias|…' matched against a measure's header, field or 'Header in Total block' text, or a formula column's name, ignoring case, spaces and punctuation. Measures join when ticked 'Show in Grand Total' AND listed here; a formula column joins when every measure it references is ticked AND its name is listed (its block value = the formula over the block's totals, like the bottom row). The bottom grand-total row still carries every ticked measure. Empty list = every ticked measure and every qualifying formula joins. Baked into the tile as rowTotalColumns at Generate — published tiles need Update Configuration to pick up an edit.",
    "drillRowTotalColumnsPreset": [
      "Net Sales|Sales|Revenue|Rev",
      "Price change percentage|Price Change %|Price %|Price Change",
      "Impact"
    ],
    "drillDataModes": [
      {
        "label": "Client-side (multiple datasets, pivot columns, formulas)",
        "value": "client"
      },
      {
        "label": "Backend tree (legacy dimensions + measures compute)",
        "value": "server"
      }
    ],
    "// dateTimePartsOptions": "Format 'Show' choices under 'Readable date & time': the whole timestamp, the date alone or the time alone.",
    "dateTimePartsOptions": [
      { "label": "Date & time (20 Oct 2026, 4:58 PM)", "value": "datetime" },
      { "label": "Date only (20 Oct 2026)", "value": "date" },
      { "label": "Time only (4:58 PM)", "value": "time" }
    ],
    "// rowFilterPresetOptions": "Format 'Show rows' choices. Each value is a row rule like 'Show only rows where': column = value | value (several rules joined with ;). An empty value shows every row. Edit the column name to match the table's status column.",
    "rowFilterPresetOptions": [
      { "label": "All rows", "value": "" },
      { "label": "Approved only", "value": "approval_status = APPROVED" },
      { "label": "Waiting for approval only", "value": "approval_status = WAITING_FOR_APPROVAL" },
      { "label": "Approved or waiting", "value": "approval_status = APPROVED | WAITING_FOR_APPROVAL" }
    ],
    "// tmAggregations": "Row/group roll-up aggregation for Normal tables.",
    "tmAggregations": [
      {
        "label": "None (raw rows)",
        "value": "none"
      },
      {
        "label": "Sum",
        "value": "sum"
      },
      {
        "label": "Average",
        "value": "avg"
      },
      {
        "label": "Count",
        "value": "count"
      },
      {
        "label": "Distinct",
        "value": "distinct"
      },
      {
        "label": "Minimum",
        "value": "min"
      },
      {
        "label": "Maximum",
        "value": "max"
      }
    ],
    "// measureAggregations + rollUpStrategies": "Reused for the Drill-Down type's measures (same as the existing drill-down-table.json). Kept here so table-matrix is self-sufficient; array-concat merge with drill-down-table.json is harmless (identical entries).",
    "measureAggregations": [
      {
        "label": "None (raw value)",
        "value": "NONE"
      },
      {
        "label": "Sum",
        "value": "SUM"
      },
      {
        "label": "Average",
        "value": "AVG"
      },
      {
        "label": "Count",
        "value": "COUNT"
      }
    ],
    "rollUpStrategies": [
      {
        "label": "Sum",
        "value": "SUM"
      },
      {
        "label": "Average",
        "value": "AVG"
      },
      {
        "label": "Minimum",
        "value": "MIN"
      },
      {
        "label": "Maximum",
        "value": "MAX"
      }
    ],
    "// tmColumnTypes / tmColumnControls / tmConditionalOperators": "Option lists for per-column config (type/align/control) and conditional-format rules.",
    "tmColumnTypes": [
      {
        "label": "Text",
        "value": "text"
      },
      {
        "label": "Number",
        "value": "number"
      },
      {
        "label": "Currency",
        "value": "currency"
      },
      {
        "label": "Percent",
        "value": "percent"
      },
      {
        "label": "Date",
        "value": "date"
      }
    ],
    "tmColumnAlignments": [
      {
        "label": "Left",
        "value": "start"
      },
      {
        "label": "Center",
        "value": "center"
      },
      {
        "label": "Right",
        "value": "end"
      }
    ],
    "// tmColumnControls": "Editable per-column input controls — full 17-control set. Multiselect/radio/lookup/autocomplete read a per-column `options` list (or `lookupUrl` for live fetch); button/hyperlink use `buttonAction`/`hrefTemplate`.",
    "tmColumnControls": [
      {
        "label": "Text box",
        "value": "text"
      },
      {
        "label": "Number",
        "value": "number"
      },
      {
        "label": "Currency",
        "value": "currency"
      },
      {
        "label": "Percentage",
        "value": "percent"
      },
      {
        "label": "Dropdown",
        "value": "dropdown"
      },
      {
        "label": "Multi select",
        "value": "multiselect"
      },
      {
        "label": "Checkbox",
        "value": "checkbox"
      },
      {
        "label": "Toggle",
        "value": "toggle"
      },
      {
        "label": "Date",
        "value": "date"
      },
      {
        "label": "Date & time",
        "value": "datetime"
      },
      {
        "label": "Text area",
        "value": "textarea"
      },
      {
        "label": "File upload",
        "value": "file"
      },
      {
        "label": "Lookup",
        "value": "lookup"
      },
      {
        "label": "Auto complete",
        "value": "autocomplete"
      },
      {
        "label": "Radio button",
        "value": "radio"
      },
      {
        "label": "Button",
        "value": "button"
      },
      {
        "label": "Hyperlink",
        "value": "hyperlink"
      }
    ],
    "// tmColumnActionKinds": "What an ACTION column's per-row button does on click. Consumed by the action column config (TableMatrixColumn.actionKind): 'api' fires actionUrl and toasts; 'rowPopup' opens a modal listing that row's fields; 'apiPopup' fires actionUrl and renders the JSON response in the modal; 'popupComponent' opens a POPUP component from this dashboard (picked via popupComponentId), rendering its full content blocks - heading / text / key-value / table / apiTable / buttons / divider - with {field} substituted from the clicked row; 'emit' only emits the cellAction output for the host to handle.",
    "tmColumnActionKinds": [
      {
        "label": "Call API",
        "value": "api"
      },
      {
        "label": "Row details popup",
        "value": "rowPopup"
      },
      {
        "label": "API popup (show response)",
        "value": "apiPopup"
      },
      {
        "label": "Popup component (blocks)",
        "value": "popupComponent"
      },
      {
        "label": "Emit event only",
        "value": "emit"
      }
    ],
    "// tmColumnActionMethods": "HTTP verb for an action column's actionUrl.",
    "tmColumnActionMethods": [
      {
        "label": "POST",
        "value": "POST"
      },
      {
        "label": "GET",
        "value": "GET"
      },
      {
        "label": "PUT",
        "value": "PUT"
      },
      {
        "label": "DELETE",
        "value": "DELETE"
      }
    ],
    "tmConditionalOperators": [
      {
        "label": "Greater than",
        "value": ">"
      },
      {
        "label": "Greater or equal",
        "value": ">="
      },
      {
        "label": "Less than",
        "value": "<"
      },
      {
        "label": "Less or equal",
        "value": "<="
      },
      {
        "label": "Equal",
        "value": "="
      },
      {
        "label": "Not equal",
        "value": "!="
      },
      {
        "label": "Between",
        "value": "between"
      }
    ],
    "// tmInitialFilterOperators": "Operators for the `initialFilters` rows (default column filters applied on first load, before any global filter). Each row resolves to one { filterKey, filterOperator, filterValue } entry sent verbatim to the backend on the initial data request.",
    "tmInitialFilterOperators": [
      {
        "label": "Equals",
        "value": "eq"
      },
      {
        "label": "Not equals",
        "value": "neq"
      },
      {
        "label": "Contains",
        "value": "contains"
      },
      {
        "label": "In (comma-separated list)",
        "value": "in"
      },
      {
        "label": "Greater than",
        "value": "gt"
      },
      {
        "label": "Greater or equal",
        "value": "gte"
      },
      {
        "label": "Less than",
        "value": "lt"
      },
      {
        "label": "Less or equal",
        "value": "lte"
      }
    ],
    "tmRowSelectionModes": [
      {
        "label": "None",
        "value": "none"
      },
      {
        "label": "Single",
        "value": "single"
      },
      {
        "label": "Multiple",
        "value": "multi"
      }
    ],
    "tmDensities": [
      {
        "label": "Comfortable",
        "value": "comfortable"
      },
      {
        "label": "Compact",
        "value": "compact"
      }
    ],
    "tmEditModes": [
      {
        "label": "Cell (edit one cell at a time)",
        "value": "cell"
      },
      {
        "label": "Row (edit the whole row)",
        "value": "row"
      }
    ],
    "// tmDefaultSortModes": "Stable default row order while the user has not clicked a column sort. 'firstColumn' keeps the order deterministic across filter/compute calls; 'none' shows rows exactly as the backend returned them.",
    "tmDefaultSortModes": [
      {
        "label": "First column (stable)",
        "value": "firstColumn"
      },
      {
        "label": "Keep backend order",
        "value": "none"
      }
    ],
    "tmSortDirections": [
      {
        "label": "Ascending (A→Z, low→high)",
        "value": "asc"
      },
      {
        "label": "Descending (Z→A, high→low)",
        "value": "desc"
      }
    ],
    "// drillTotalsPlacements": "Drill-Down build-form 'Totals' picker (payload/caps `totalsPlacement`). bottom = grand-total row only; right = trailing Total block across the pivot column values only; left = the same Total block placed directly after the first-level column (Market Segment | TOTAL | NACA | APAC | …), no total row; both = row + trailing block (Figma Customer Spec Impact, default); both-left = row + block after the first column (APA Aims to Cover Cost); none = neither. The block's side is baked into the tile as rowTotalPosition at Generate. Reorder / remove entries to change what the picker offers.",
    "drillTotalsPlacements": [
      {
        "label": "Bottom and right (total row + Total block)",
        "value": "both"
      },
      {
        "label": "Bottom and left (total row + Total block after the first column)",
        "value": "both-left"
      },
      {
        "label": "Right only (Total block across pivot columns)",
        "value": "right"
      },
      {
        "label": "Left only (Total block after the first column)",
        "value": "left"
      },
      {
        "label": "Bottom only (grand-total row)",
        "value": "bottom"
      },
      {
        "label": "None",
        "value": "none"
      }
    ],
    "// drillHeaderGroupModes":"Drill-Down 'Header grouping' (Format popup, drillHeaderGroupBy) — which label spans the two-tier header when pivot column dimensions are set. measure = 'Sales' over Mining|Rail|Marine (legacy); column = 'Mining' over Sales|Price %|Reason (Figma Customer Spec Impact layout).",
    "drillHeaderGroupModes": [
      {
        "label": "Measure on top (Sales → Mining | Rail | Marine)",
        "value": "measure"
      },
      {
        "label": "Column value on top (Mining → Sales | Price % | Reason)",
        "value": "column"
      }
    ],
    "// tmDrillLevel2ColorBy": "Drill-Down level-2 row tint. 'parent' = ONE uniform tint for every level-2 row (the band under each level-1 parent); 'label' = identical level-2 labels share a tint, distinct labels get distinct tints.",
    "tmDrillLevel2ColorBy": [
      {
        "label": "None (plain grey)",
        "value": "none"
      },
      {
        "label": "Parent group (level 1)",
        "value": "parent"
      },
      {
        "label": "Level-2 label",
        "value": "label"
      }
    ],
    "// tmCellDisplays / tmCellRuleOperators": "GENERIC per-column cell configuration (table-cell-config.ts) — the ONE editor shared by Normal / Editable table columns and Drill-Down measures / dimensions. tmCellDisplays = how a cell value is drawn; tmCellRuleOperators = the conditions a formatting rule can test (first matching rule wins; a rule may test another column via its field).",
    "tmCellDisplays": [
      { "label": "Plain text", "value": "text" },
      { "label": "Badge / pill", "value": "badge" },
      { "label": "Data bar", "value": "databar" },
      { "label": "Progress bar (0-100)", "value": "progress" },
      { "label": "Heat map", "value": "heatmap" },
      { "label": "Trend arrow", "value": "trend" },
      { "label": "Colour dot + value", "value": "icon" },
      { "label": "Link", "value": "link" }
    ],
    "// tmBadgeFills / valueColors": "Cell formatting → 'Value colours' (cellConfig.valueColors) is a flat value → colour map for a text column such as OEM Position: [{ value: 'MFN', color: '#172033' }, { value: 'Strategic OEM', color: '#3a9b6f' }, …] (an object { 'MFN': '#172033', … } is accepted from hand-written config; textColor / label per entry are optional). With display 'badge' the colour paints the chip — tmBadgeFills picks 'solid' (the colour as the fill under white / dark text, the design's OEM Position look — the default once value colours exist) or 'soft' (coloured text over a translucent wash — the default for a badge without value colours); cellConfig.badgeFill stores the choice; with any other display the colour is the value's text colour (and the dot / bar accent). A matching conditional rule still overrides. Same contract for nested-table.json and drill-down-table.json.",
    "tmBadgeFills": [
      { "label": "Soft tint (coloured text)", "value": "soft" },
      { "label": "Solid fill (white / dark text)", "value": "solid" }
    ],
    "tmCellEditors": [
      { "label": "Read-only", "value": "none" },
      { "label": "Text box", "value": "text" },
      { "label": "Number", "value": "number" },
      { "label": "Dropdown", "value": "dropdown" },
      { "label": "Checkbox", "value": "checkbox" },
      { "label": "Date", "value": "date" },
      { "label": "Multi-line text", "value": "textarea" }
    ],
    "tmCellRuleOperators": [
      { "label": "Greater than", "value": ">" },
      { "label": "Greater or equal", "value": ">=" },
      { "label": "Less than", "value": "<" },
      { "label": "Less or equal", "value": "<=" },
      { "label": "Equals", "value": "=" },
      { "label": "Not equal", "value": "!=" },
      { "label": "Between", "value": "between" },
      { "label": "Contains", "value": "contains" },
      { "label": "Does not contain", "value": "notContains" },
      { "label": "Starts with", "value": "startsWith" },
      { "label": "Ends with", "value": "endsWith" },
      { "label": "Is one of (comma-separated)", "value": "in" },
      { "label": "Is not one of (comma-separated)", "value": "notIn" },
      { "label": "Is empty", "value": "empty" },
      { "label": "Is not empty", "value": "notEmpty" },
      { "label": "Always (catch-all)", "value": "any" }
    ],
    "// tmDrillVisuals": "Per-measure visual for the Drill-Down table (applied to every measure column). Sparkline/mini-bar need array-valued measure cells from the backend.",
    "tmDrillVisuals": [
      {
        "label": "None (plain numbers)",
        "value": "none"
      },
      {
        "label": "Data bars",
        "value": "databar"
      },
      {
        "label": "Progress bars",
        "value": "progress"
      },
      {
        "label": "Heat map",
        "value": "heatmap"
      },
      {
        "label": "Trend indicators",
        "value": "trend"
      },
      {
        "label": "Color-coded icons",
        "value": "icon"
      },
      {
        "label": "Sparkline (array cells)",
        "value": "sparkline"
      },
      {
        "label": "Mini bars (array cells)",
        "value": "minibar"
      }
    ],
    "// tmYearFilterBases": "Where the latest-N-years filter anchors its window: the highest year present in the data (default — fiscal/planning data carries FUTURE years, so 2024–2028 with count 3 must mean 2026/2027/2028), or today's system year (opt-in to hide future years).",
    "tmYearFilterBases": [
      {
        "label": "Data (highest year present)",
        "value": "data"
      },
      {
        "label": "Current system year",
        "value": "current"
      }
    ],
    "// tableMatrixChartDefaults": "ALL styling + layout constants for the unified table-matrix component — every value config-driven so NOTHING is baked into code. The component reads these (with a last-resort FALLBACK only for standalone/no-config runs).",
    "tableMatrixChartDefaults": {
      "palette": [
        "#1f6feb",
        "#10b981",
        "#f59e0b",
        "#ef4444",
        "#8b5cf6",
        "#06b6d4",
        "#ec4899",
        "#84cc16"
      ],
      "headerBackground": "#f1f5f9",
      "headerColor": "#334155",
      "rowBackground": "#ffffff",
      "rowAltBackground": "#f8fafc",
      "borderColor": "#e2e8f0",
      "textColor": "#172033",
      "fontSize": 13,
      "rowHeight": 40,
      "compactRowHeight": 32,
      "totalRowBackground": "#f8fafc",
      "totalRowColor": "#172033",
      "defaultColumnWidth": 140,
      "pageSize": 0
    },
    "// formatControls": "The Table & Matrix Format-popup / build-form controls (all `appliesTo:[\"TABLE_MATRIX\"]`). `visibleWhenType` gates a control to specific table types (e.g. editing controls only for editable). Reuses shared option lists (numberScales, paletteOptions).",
    "formatControls": [
      {
        "key": "showValues",
        "label": "Show cell values",
        "control": "toggle",
        "default": true,
        "enabled": true,
        "group": "Formatting",
        "appliesTo": [
          "TABLE_MATRIX"
        ]
      },
      {
        "key": "numberFormat",
        "label": "Number format",
        "control": "select",
        "optionsKey": "numberScales",
        "default": "none",
        "enabled": true,
        "group": "Formatting",
        "appliesTo": [
          "TABLE_MATRIX"
        ]
      },
      {
        "key": "decimals",
        "label": "Decimal places (round off)",
        "control": "number",
        "default": 0,
        "min": 0,
        "max": 6,
        "step": 1,
        "enabled": true,
        "group": "Formatting",
        "appliesTo": [
          "TABLE_MATRIX"
        ]
      },
      {
        "key": "dateTimeFormat",
        "label": "Readable date & time (e.g. 20 Oct 2026, 4:58 PM)",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Formatting",
        "appliesTo": [
          "TABLE_MATRIX"
        ]
      },
      {
        "key": "dateTimeParts",
        "label": "Show",
        "control": "select",
        "optionsKey": "dateTimePartsOptions",
        "default": "datetime",
        "enabled": true,
        "group": "Formatting",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhen": {
          "key": "dateTimeFormat",
          "values": [
            true
          ]
        }
      },
      {
        "key": "palette",
        "label": "Color palette",
        "control": "select",
        "optionsKey": "paletteOptions",
        "default": "default",
        "enabled": true,
        "group": "Formatting",
        "appliesTo": [
          "TABLE_MATRIX"
        ]
      },
      {
        "key": "density",
        "label": "Row density",
        "control": "select",
        "optionsKey": "tmDensities",
        "default": "comfortable",
        "enabled": true,
        "group": "Formatting",
        "appliesTo": [
          "TABLE_MATRIX"
        ]
      },
      {
        "key": "striped",
        "label": "Striped rows",
        "control": "toggle",
        "default": true,
        "enabled": true,
        "group": "Formatting",
        "appliesTo": [
          "TABLE_MATRIX"
        ]
      },
      {
        "key": "showColumnLines",
        "label": "Column lines (vertical borders)",
        "control": "toggle",
        "default": true,
        "enabled": true,
        "group": "Formatting",
        "appliesTo": [
          "TABLE_MATRIX"
        ]
      },
      {
        "key": "headerBackground",
        "label": "Header background",
        "control": "color",
        "default": "#f1f5f9",
        "enabled": true,
        "group": "Formatting",
        "appliesTo": [
          "TABLE_MATRIX"
        ]
      },
      {
        "key": "headerColor",
        "label": "Header text color",
        "control": "color",
        "default": "#334155",
        "enabled": true,
        "group": "Formatting",
        "appliesTo": [
          "TABLE_MATRIX"
        ]
      },
      {
        "key": "headerFontSize",
        "label": "Header font size (px, 0 = same as table)",
        "control": "number",
        "default": 0,
        "min": 0,
        "max": 48,
        "step": 1,
        "enabled": true,
        "group": "Formatting",
        "appliesTo": [
          "TABLE_MATRIX"
        ]
      },
      {
        "key": "showSubtotals",
        "label": "Show subtotals (grouped)",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Totals",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal",
          "grouped"
        ]
      },
      {
        "key": "showGrandTotal",
        "label": "Show grand total",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Totals",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal",
          "editable",
          "matrix",
          "pivot",
          "grouped"
        ]
      },
      {
        "key": "grandTotalLabel",
        "label": "Total row label",
        "control": "text",
        "default": "Grand Total",
        "enabled": true,
        "group": "Totals",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal",
          "editable",
          "matrix",
          "pivot",
          "grouped"
        ],
        "hint": "Text in the first column of the total row at the end of the table."
      },
      {
        "key": "groupsExpanded",
        "label": "Start groups expanded",
        "control": "toggle",
        "default": true,
        "enabled": true,
        "group": "Totals",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "grouped",
          "treegrid"
        ]
      },
      {
        "key": "stickyHeader",
        "label": "Sticky header",
        "control": "toggle",
        "default": true,
        "enabled": true,
        "group": "Columns",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal",
          "editable",
          "matrix",
          "pivot",
          "grouped",
          "treegrid",
          "financial"
        ],
        "hint": "Not offered on the Drill-Down table: its header is always fixed above the scrolling rows."
      },
      {
        "key": "stickyFooter",
        "label": "Sticky footer (totals stay in view)",
        "control": "toggle",
        "default": true,
        "enabled": true,
        "group": "Columns",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal",
          "editable"
        ],
        "hint": "On (default): the total row is pinned at the bottom of the table's scroll area, so it is visible without scrolling to the last row. Off: it sits after the last row. Drill-Down tables place their grand-total row through the Totals picker instead (Bottom / Both = sticky bottom row)."
      },
      {
        "key": "freezeFirstColumn",
        "label": "Freeze first column",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Columns",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "hint": "Pins the first column while the table scrolls sideways. On the Drill-Down table that is the hierarchy (first-level) column; the Total row's label and the header band stay aligned with it."
      },
      {
        "key": "freezeColumnCount",
        "label": "Freeze N left columns (0 = none)",
        "control": "number",
        "default": 0,
        "min": 0,
        "max": 6,
        "step": 1,
        "enabled": true,
        "group": "Columns",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal",
          "editable",
          "drilldown"
        ],
        "hint": "Overrides 'Freeze first column' when > 0. Drill-Down: counts VISIBLE columns (a collapsed level column is skipped), e.g. 2 with a left-placed Total block pins the hierarchy column + TOTAL."
      },
      {
        "key": "freezeRowCount",
        "label": "Freeze N top rows (0 = none)",
        "control": "number",
        "default": 0,
        "min": 0,
        "max": 10,
        "step": 1,
        "enabled": true,
        "group": "Columns",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal",
          "editable",
          "drilldown"
        ],
        "hint": "Pins the top N rows under the header while the rest scroll. Drill-Down: the first N rows as currently rendered (expanding a parent changes which rows those are)."
      },
      {
        "// column show/hide": "There is deliberately no end-user 'Columns' menu. Visibility is CONFIG-DRIVEN: each column's `hidden` flag (the per-column 'Hidden' checkbox in the builder's column list) removes it from the rendered table while KEEPING it in the save payload."
      },
      {
        "key": "enableColumnReorder",
        "label": "Drag to reorder columns",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Columns",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal",
          "editable"
        ]
      },
      {
        "key": "enableColumnResize",
        "label": "Drag to resize columns",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Columns",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal"
        ]
      },
      {
        "key": "pageSize",
        "label": "Rows per page (0 = all)",
        "control": "number",
        "default": 0,
        "min": 0,
        "max": 500,
        "step": 5,
        "enabled": true,
        "group": "Columns",
        "appliesTo": [
          "TABLE_MATRIX"
        ]
      },
      {
        "key": "virtualScroll",
        "label": "Scroll large datasets",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Columns",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal"
        ]
      },
      {
        "key": "defaultSort",
        "label": "Default sort order",
        "control": "select",
        "optionsKey": "tmDefaultSortModes",
        "default": "firstColumn",
        "enabled": true,
        "group": "Interaction",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal",
          "editable"
        ]
      },
      {
        "key": "defaultSortDir",
        "label": "Default sort direction",
        "control": "select",
        "optionsKey": "tmSortDirections",
        "default": "asc",
        "enabled": true,
        "group": "Interaction",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal",
          "editable"
        ]
      },
      {
        "key": "enableSearch",
        "label": "Global search box",
        "control": "toggle",
        "default": true,
        "enabled": true,
        "group": "Interaction",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal",
          "editable",
          "grouped",
          "treegrid",
          "financial"
        ]
      },
      {
        "key": "enableColumnSearch",
        "label": "Per-column search row",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Interaction",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal"
        ]
      },
      {
        "key": "enableAdvancedFilter",
        "label": "Advanced column filters",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Interaction",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal"
        ]
      },
      {
        "key": "enableValueFilter",
        "label": "Filter by column values (Excel-style)",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Interaction",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal"
        ]
      },
      {
        "key": "rowFilterPreset",
        "label": "Show rows",
        "control": "select",
        "optionsKey": "rowFilterPresetOptions",
        "default": "",
        "enabled": true,
        "group": "Interaction",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "hint": "Pick which rows the table shows. The choices (and the column/values each one keeps) are set in options.rowFilterPresetOptions of this file."
      },
      {
        "key": "fixedRowFilter",
        "label": "Show only rows where (e.g. Approval Status = Approved; Approver = {userEmail})",
        "control": "text",
        "default": "",
        "enabled": true,
        "group": "Interaction",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal",
          "editable"
        ]
      },
      {
        "key": "rowSelection",
        "label": "Row selection",
        "control": "select",
        "optionsKey": "tmRowSelectionModes",
        "default": "single",
        "enabled": true,
        "group": "Interaction",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal",
          "editable"
        ]
      },
      {
        "key": "rowCheckbox",
        "label": "Row checkboxes (tick rows)",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Interaction",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal",
          "editable",
          "matrix",
          "pivot",
          "grouped"
        ],
        "hint": "A checkbox column on the left; the header checkbox ticks every row on the page. Ticked rows are the selection bulk edit / workflow actions work on."
      },
      {
        "key": "rowCheckboxColumn",
        "label": "Checkbox column",
        "control": "column-select",
      
        "default": "",
        "enabled": true,
        "group": "Interaction",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal",
          "editable",
          "matrix",
          "pivot",
          "grouped"
        ],
        "visibleWhen": {
          "key": "rowCheckbox",
          "values": [
            true
          ]
        },
        "hint": "Draw the checkbox inside this column's cells, before the value (its header gets the select-all box). Blank keeps the separate checkbox column on the left."
      },
      {
        "key": "rowCheckboxSelectAll",
        "label": "Select-all checkbox in header",
        "control": "toggle",
        "default": true,
        "enabled": true,
        "group": "Interaction",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal",
          "editable",
          "matrix",
          "pivot",
          "grouped"
        ],
        "visibleWhen": {
          "key": "rowCheckbox",
          "values": [
            true
          ]
        },
        "hint": "Off: the header shows no checkbox, so rows are ticked one by one only."
      },
      {
        "key": "crossFilter",
        "label": "Publish cross-filter on row click",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Interaction",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal"
        ]
      },
      {
        "key": "enableRefresh",
        "label": "Show Refresh button",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Interaction",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal"
        ]
      },
      {
        "key": "enableSavePrefs",
        "label": "Save user view (columns/sort)",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Interaction",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal"
        ]
      },
      { "// Row actions": "Built-in per-row buttons in a trailing Actions column, for every table type but Drill-Down, each working out of the box: View opens that row's details popup, Copy adds a duplicate of the row right below it (a new row in an Editable table), Delete removes it, Save posts the row's unsaved changes. Save and Delete use the CRUD group's endpoints when set (Delete endpoint / Create + Update endpoints, else the Save endpoint): the row is posted as a delete / create / update operation and settles once the backend answers. Without an endpoint Delete removes the row client-side (marks it when 'Soft delete' is on) and Save emits the component's save output. Each click also emits the rowAction output. Independent of the Editable type's own row tools." },
      {
        "key": "rowActionView",
        "label": "View button (row details)",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Row actions",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal",
          "editable",
          "matrix",
          "pivot",
          "grouped",
          "treegrid",
          "financial"
        ]
      },
      {
        "key": "rowActionCopy",
        "label": "Copy button (duplicate row)",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Row actions",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal",
          "editable",
          "matrix",
          "pivot",
          "grouped",
          "treegrid",
          "financial"
        ]
      },
      {
        "key": "rowActionDelete",
        "label": "Delete button",
        "hint": "Removes the row. With a Delete endpoint (or Save endpoint) in the CRUD group it is deleted through that API and disappears once the backend confirms.",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Row actions",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal",
          "editable",
          "matrix",
          "pivot",
          "grouped",
          "treegrid",
          "financial"
        ]
      },
      {
        "key": "rowActionSave",
        "label": "Save button (post row changes)",
        "hint": "Live while the row has unsaved changes. Posts them through the CRUD group's Create / Update / Delete endpoints (else the Save endpoint); without any endpoint the table's save output hands them to the host.",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Row actions",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal",
          "editable",
          "matrix",
          "pivot",
          "grouped",
          "treegrid",
          "financial"
        ]
      },
      {
        "key": "rowActionsHeader",
        "label": "Actions column header",
        "control": "text",
        "default": "Actions",
        "enabled": true,
        "group": "Row actions",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal",
          "editable",
          "matrix",
          "pivot",
          "grouped",
          "treegrid",
          "financial"
        ]
      },
      {
        "key": "rowActionDeleteConfirm",
        "label": "Confirm before delete (blank = none)",
        "control": "text",
        "default": "",
        "enabled": true,
        "group": "Row actions",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal",
          "editable",
          "matrix",
          "pivot",
          "grouped",
          "treegrid",
          "financial"
        ]
      },
      {
        "key": "enableExport",
        "label": "Enable CSV export",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Export",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal",
          "editable",
          "matrix",
          "pivot",
          "grouped",
          "treegrid",
          "financial"
        ]
      },
      {
        "key": "enableExcelExport",
        "label": "Enable Excel export",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Export",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal",
          "matrix",
          "pivot",
          "grouped",
          "financial"
        ]
      },
      {
        "key": "enablePdfExport",
        "label": "Enable PDF export",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Export",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal",
          "matrix",
          "pivot",
          "grouped",
          "financial"
        ]
      },
      {
        "key": "enablePrint",
        "label": "Enable Print",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Export",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal",
          "matrix",
          "pivot",
          "grouped",
          "financial"
        ]
      },
      {
        "key": "enableUpload",
        "label": "Enable file upload",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Upload",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal",
          "editable"
        ]
      },
      {
        "key": "uploadButtonLabel",
        "label": "Upload button label",
        "control": "text",
        "default": "Upload",
        "enabled": true,
        "group": "Upload",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal",
          "editable"
        ]
      },
      {
        "key": "uploadAccept",
        "label": "Accepted file types",
        "control": "text",
        "default": ".xlsx,.xls,.csv",
        "enabled": true,
        "group": "Upload",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal",
          "editable"
        ]
      },
      {
        "key": "uploadUrl",
        "label": "Upload endpoint (blank = compute API)",
        "control": "text",
        "default": "",
        "enabled": true,
        "group": "Upload",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "normal",
          "editable"
        ]
      },
      {
        "// Editable group": "CLIENT-SIDE CRUD + change-tracking (all gated to the editable type). Row ops, undo/redo, validation, and change-state badges are fully client-side. saveUrl/bulkSaveUrl + enableWorkflow are DECLARED only — the component emits a `save` event with the bulk payload; nothing is POSTed until the backend contract is confirmed."
      },
      {
        "key": "editMode",
        "label": "Edit mode",
        "control": "select",
        "optionsKey": "tmEditModes",
        "default": "cell",
        "enabled": true,
        "group": "Editable",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "editable",
          "drilldown"
        ]
      },
      {
        "key": "enableRowAdd",
        "label": "Allow add row",
        "control": "toggle",
        "default": true,
        "enabled": true,
        "group": "Editable",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "editable"
        ]
      },
      {
        "key": "enableRowInsert",
        "label": "Allow insert above/below",
        "control": "toggle",
        "default": true,
        "enabled": true,
        "group": "Editable",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "editable"
        ]
      },
      {
        "key": "enableRowDelete",
        "label": "Allow delete row",
        "control": "toggle",
        "default": true,
        "enabled": true,
        "group": "Editable",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "editable"
        ]
      },
      {
        "key": "enableSoftDelete",
        "label": "Soft delete (mark, keep row)",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Editable",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "editable"
        ]
      },
      {
        "key": "enableRowDuplicate",
        "label": "Allow duplicate row",
        "control": "toggle",
        "default": true,
        "enabled": true,
        "group": "Editable",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "editable"
        ]
      },
      {
        "key": "enableCopyPaste",
        "label": "Allow copy / paste row",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Editable",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "editable"
        ]
      },
      {
        "key": "enableUndoRedo",
        "label": "Undo / redo",
        "control": "toggle",
        "default": true,
        "enabled": true,
        "group": "Editable",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "editable"
        ]
      },
      {
        "key": "showRowState",
        "label": "Show row state badge",
        "control": "toggle",
        "default": true,
        "enabled": true,
        "group": "Editable",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "editable"
        ]
      },
      {
        "key": "enableValidation",
        "label": "Validate on edit",
        "control": "toggle",
        "default": true,
        "enabled": true,
        "group": "Editable",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "editable"
        ]
      },
      {
        "key": "enableRowSave",
        "label": "Per-row Save button",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Editable",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "editable"
        ]
      },
      {
        "key": "enableBulkEdit",
        "label": "Bulk edit (fill selected rows)",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Editable",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "editable"
        ]
      },
      {
        "key": "enableAutoSave",
        "label": "Auto-save edits",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Editable",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "editable"
        ]
      },
      {
        "key": "autoSaveDebounceMs",
        "label": "Auto-save delay (ms)",
        "control": "number",
        "default": 1200,
        "min": 200,
        "max": 10000,
        "step": 100,
        "enabled": true,
        "group": "Editable",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "editable"
        ]
      },
      {
        "key": "saveOnRowExit",
        "label": "Save on row exit",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Editable",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "editable"
        ]
      },
      {
        "// CRUD group": "Backend CRUD — generic config-driven contract. Each URL is optional: when set the component POSTs for real (create/update/delete by row state, or one bulk call); blank = emit the payload for the parent to wire. Optimistic locking sends the version field so the backend can 409 stale writes; failures roll back client-side."
      },
      {
        "// requestBodyEditor": "Each endpoint above carries `requestBodyEditor: true`, which renders a 'Body' button beside its label in the Format popup. That button opens the custom request-body editor for THAT endpoint alone, saved under format.payloadTemplates[<endpoint key>] — so createUrl and updateUrl can post entirely different contracts. An endpoint with no entry posts the default { componentId, dataset, operation, rows, transactional } shape. A configured endpoint instead posts { [dataKey||'requestData']: { ...staticValues, ...row values }, endpoints: [...], ...extraFields }, one POST per dirty row (this contract has no bulk-array shape). The row's own column values are the DYNAMIC part — always sent, never configured; staticValues/endpoints/extraFields are the STATIC scaffolding. Example: \"payloadTemplates\": { \"updateUrl\": { \"dataKey\": \"requestData\", \"staticValues\": { \"vertical\": \"Mining\" }, \"endpoints\": [ { \"functionName\": \"GeneratedService\", \"version\": \"1.0\" } ], \"extraFields\": { \"entity\": \"default_entity\", \"workflowId\": \"default_workflow\", \"version\": \"1.0\" } } }"
      },
      {
        "key": "createUrl",
        "label": "Create endpoint (new rows)",
        "control": "text",
        "default": "",
        "enabled": true,
        "requestBodyEditor": true,
        "group": "CRUD",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "editable"
        ]
      },
      {
        "key": "updateUrl",
        "label": "Update endpoint (modified rows)",
        "control": "text",
        "default": "",
        "enabled": true,
        "requestBodyEditor": true,
        "group": "CRUD",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "editable",
          "drilldown"
        ]
      },
      {
        "key": "deleteUrl",
        "label": "Delete endpoint (removed rows)",
        "control": "text",
        "default": "",
        "enabled": true,
        "requestBodyEditor": true,
        "group": "CRUD",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "editable"
        ]
      },
      {
        "key": "saveUrl",
        "label": "Save endpoint (single-row fallback)",
        "control": "text",
        "default": "",
        "enabled": true,
        "requestBodyEditor": true,
        "group": "CRUD",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "editable",
          "drilldown"
        ]
      },
      {
        "key": "bulkSaveUrl",
        "label": "Bulk-save endpoint (Save all)",
        "control": "text",
        "default": "",
        "enabled": true,
        "requestBodyEditor": true,
        "group": "CRUD",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "editable"
        ]
      },
      {
        "key": "enableOptimisticLock",
        "label": "Optimistic locking",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "CRUD",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "editable"
        ]
      },
      {
        "key": "versionField",
        "label": "Version/etag field",
        "control": "text",
        "default": "",
        "enabled": true,
        "group": "CRUD",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "editable"
        ]
      },
      {
        "key": "transactional",
        "label": "Bulk save as one transaction",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "CRUD",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "editable"
        ]
      },
      {
        "// Workflow group": "Workflow actions act on the SELECTED rows; each POSTs to workflowUrl (or emits when blank). Comments/attachments/activity are surfaced per-row when enabled."
      },
      {
        "key": "enableWorkflow",
        "label": "Enable workflow toolbar",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Workflow",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "editable"
        ]
      },
      {
        "key": "workflowUrl",
        "label": "Workflow endpoint",
        "control": "text",
        "default": "",
        "enabled": true,
        "group": "Workflow",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "editable"
        ]
      },
      {
        "key": "enableComments",
        "label": "Row comments",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Workflow",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "editable"
        ]
      },
      {
        "key": "enableAttachments",
        "label": "Row attachments",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Workflow",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "editable"
        ]
      },
      {
        "key": "enableAuditTrail",
        "label": "Activity history / audit trail",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Workflow",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "editable"
        ]
      },
      {
        "// Title group (drill-down)": "Drill-Down surfaces its Title as an accordion (like Bar & Column) instead of the inline config field. `title` syncs to the tile title via onBarFormatChange."
      },
      {
        "key": "title",
        "label": "Chart title",
        "control": "text",
        "default": "",
        "enabled": true,
        "group": "Title",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "drilldown"
        ]
      },
      {
        "// Drill-Down group": "Analytical Drill-Down table: visual + reporting layer (client-side). Expand/collapse-all, per-measure visuals (data bars/heat map/trend/…), export/print, saved views, column dividers. Aggregations (sum/avg/YoY/ranking/…) are backend-computed measures the table just renders + formats."
      },
      {
        "key": "enableExpandCollapseAll",
        "label": "Expand / collapse all",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Drill-Down",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "drilldown"
        ]
      },
      {
        "key": "drillVisualKind",
        "label": "Measure visual",
        "control": "select",
        "optionsKey": "tmDrillVisuals",
        "default": "none",
        "enabled": true,
        "group": "Drill-Down",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "drilldown"
        ]
      },
      {
        "key": "drillVisualColor",
        "label": "Visual color",
        "control": "color",
        "default": "#3b82f6",
        "enabled": true,
        "group": "Drill-Down",
        "visibleWhen": {
          "key": "drillVisualKind",
          "values": [
            "databar",
            "progress",
            "heatmap",
            "trend",
            "icon",
            "sparkline",
            "minibar"
          ]
        },
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "drilldown"
        ]
      },
      {
        "// Level-2 colour grouping": "Tints the BACKGROUND of level-2 rows per group (12 light tints, themeable via --dvm-drilldown-group-<n>); text stays the normal dark colour."
      },
      {
        "key": "drillLevel2ColorBy",
        "label": "Colour level 2 by",
        "control": "select",
        "optionsKey": "tmDrillLevel2ColorBy",
        "default": "none",
        "enabled": true,
        "group": "Drill-Down",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "drilldown"
        ]
      },
      {
        "key": "showColumnDividers",
        "label": "Column divider lines",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Drill-Down",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "drilldown"
        ]
      },
      {
        "key": "enableExport",
        "label": "Enable CSV export",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Drill-Down",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "drilldown"
        ]
      },
      {
        "key": "enableExcelExport",
        "label": "Enable Excel export",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Drill-Down",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "drilldown"
        ]
      },
      {
        "key": "enablePdfExport",
        "label": "Enable PDF export",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Drill-Down",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "drilldown"
        ]
      },
      {
        "key": "enablePrint",
        "label": "Enable Print",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Drill-Down",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "drilldown"
        ]
      },
      {
        "key": "enableSavedViews",
        "label": "Saved views",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Drill-Down",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "drilldown"
        ]
      },
      {
        "key": "drillEditRecalcTotals",
        "label": "Recalculate totals on edit",
        "control": "toggle",
        "default": true,
        "enabled": true,
        "group": "Drill-Down",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "drilldown"
        ]
      },
      {
        "key": "drillStartExpanded",
        "label": "Start expanded (off = show only Level 1)",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Drill-Down",
        "appliesTo": [
          "TABLE_MATRIX",
          "DRILL_DOWN_TABLE"
        ],
        "visibleWhenType": [
          "drilldown"
        ],
        "hint": "Off (default): the table opens showing only the highest level (Level 1); users expand rows to drill down. On: every level starts expanded. Applied when the table is generated."
      },
      {
        "key": "drillRawLeafRows",
        "label": "Show individual rows (no combining at the last level)",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Drill-Down",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "drilldown"
        ],
        "hint": "Off (default): one row per value of the last level, its measures aggregated over all matching response rows. On: EVERY response row becomes its own leaf row with its individual values (the label repeats). Parent levels and the grand total still roll up. Client-side computation only."
      },
      {
        "key": "drillHeaderGroupBy",
        "label": "Header grouping (with pivot columns)",
        "control": "select",
        "optionsKey": "drillHeaderGroupModes",
        "default": "column",
        "enabled": true,
        "group": "Drill-Down",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "drilldown"
        ],
        "hint": "Only with pivot column dimensions. Column value (default, Figma layout): the column value spans the measures — 'Mining' over Sales | Price % | Reason, then 'Rail' over Sales | Price % | Reason. Measure: the measure spans its column values — 'Sales' over Mining | Rail | Marine, then 'Price %' over Mining | Rail | Marine. Re-generate the table after changing; tiles generated before this control existed keep their old header until regenerated."
      },
      {
        "key": "drillRowTotalLabel",
        "label": "Total block label",
        "control": "text",
        "default": "Total",
        "enabled": true,
        "group": "Drill-Down",
        "appliesTo": [
          "TABLE_MATRIX"
        ],
        "visibleWhenType": [
          "drilldown"
        ],
        "hint": "Header text of the Total block (build form → Totals = any 'right' / 'left' placement), e.g. 'Total', 'All verticals'. Re-generate after changing."
      },
      {
        "// Filters group": "Latest-N-years filter for the WHOLE table family (no visibleWhenType — every table type shows it, drill-down included; also exposed on the standalone DRILL_DOWN_TABLE). Works BOTH ways, evaluated at RENDER time so published tiles roll into the new year automatically: (1) COLUMNS whose name carries a year (e.g. '2024 Net Sales') outside the window are hidden; (2) ROWS whose year-column value (e.g. Fiscal Year = 2024) is outside the window are hidden — the year column is yearFilterField, else auto-detected. Drill-down additionally hides tree nodes whose LABEL is a year outside the window."
      },
      {
        "key": "yearFilter",
        "label": "Show only latest years",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "group": "Filters",
        "appliesTo": [
          "TABLE_MATRIX",
          "DRILL_DOWN_TABLE"
        ],
        "hint": "Keeps only the latest-N years: hides year-named columns (2024 Net Sales…), rows whose year column (e.g. Fiscal Year) is outside the window, and drill-down year levels. Values without a year always stay visible."
      },
      {
        "key": "yearFilterField",
        "label": "Year filter key (column; blank = auto-detect)",
        "control": "column-select",
        "default": "",
        "enabled": true,
        "group": "Filters",
        "appliesTo": [
          "TABLE_MATRIX",
          "DRILL_DOWN_TABLE"
        ],
        "hint": "The column whose values hold the year (e.g. fiscal_year) — the filter keys off it for row filtering. Leave blank to auto-detect a year-valued column."
      },
      {
        "key": "yearFilterCount",
        "label": "How many latest years",
        "control": "number",
        "default": 3,
        "min": 1,
        "max": 10,
        "step": 1,
        "enabled": true,
        "group": "Filters",
        "appliesTo": [
          "TABLE_MATRIX",
          "DRILL_DOWN_TABLE"
        ]
      },
      {
        "key": "yearFilterBase",
        "label": "Latest year comes from",
        "control": "select",
        "optionsKey": "tmYearFilterBases",
        "default": "data",
        "enabled": true,
        "group": "Filters",
        "appliesTo": [
          "TABLE_MATRIX",
          "DRILL_DOWN_TABLE"
        ],
        "hint": "Data (default): latest = the highest year present — data 2024–2028 with count 3 shows 2026/2027/2028 (future years included). Current system year: anchors to today's year instead, hiding future years."
      },
      { "key": "cellFontSize", "label": "Value text size (px, 0 = default)", "control": "number", "default": 0, "min": 0, "max": 40, "step": 1, "enabled": true, "group": "Text size", "appliesTo": ["TABLE_MATRIX"]},
      { "key": "level1FontSize", "label": "Level 1 value size (px, 0 = value size)", "control": "number", "default": 0, "min": 0, "max": 40, "step": 1, "enabled": true, "group": "Text size", "appliesTo": ["TABLE_MATRIX"], "visibleWhenType": ["drilldown"]},
      { "key": "level2FontSize", "label": "Level 2 value size (px, 0 = value size)", "control": "number", "default": 0, "min": 0, "max": 40, "step": 1, "enabled": true, "group": "Text size", "appliesTo": ["TABLE_MATRIX"], "visibleWhenType": ["drilldown"]},
      { "key": "level3FontSize", "label": "Level 3 value size (px, 0 = value size)", "control": "number", "default": 0, "min": 0, "max": 40, "step": 1, "enabled": true, "group": "Text size", "appliesTo": ["TABLE_MATRIX"], "visibleWhenType": ["drilldown"]},
      { "key": "level4FontSize", "label": "Level 4 value size (px, 0 = value size)", "control": "number", "default": 0, "min": 0, "max": 40, "step": 1, "enabled": true, "group": "Text size", "appliesTo": ["TABLE_MATRIX"], "visibleWhenType": ["drilldown"]},
      { "key": "tableHeaderHeight", "label": "Header height (px, 0 = default)", "control": "number", "default": 0, "min": 0, "max": 120, "step": 1, "enabled": true, "group": "Header & lines", "appliesTo": ["TABLE_MATRIX"]}
    ]
  }
}
